import { ToastVariant } from '../components/ToastMessages/types';
import { Dispatch } from 'redux';
import { QueryTypeEnum, RelationTypeEnum } from './lineage.utils';
import { ReactElement } from 'react';
export { getSearchableFields } from './searchable.utils';

const getPropertyByDotNotationIndex = <T,>(entity: T, dotNotationIndex: string): unknown => {
  try {
    const property = dotNotationIndex
      .split('.')
      // @ts-ignore
      .reduce((acc, key) => acc[key as keyof T], entity);
    // @ts-ignore
    return property?.value ? property.value : property;
  } catch (_) {
    return undefined;
  }
};

type PropertyByDotNotationIndexType = <T>(entity: T, dotNotationIndex: string) => unknown;

export const getByDot: PropertyByDotNotationIndexType = getPropertyByDotNotationIndex;

export const uniqueId = (length = 16) => {
  return parseInt(
    Math.ceil(Math.random() * Date.now())
      .toPrecision(length)
      .toString()
      .replace('.', '')
  );
};

/**
 * @deprecated Use useToast hook instead.
 * Migration:
 * import { useToast } from 'hooks/useToast';
 * const { showToast } = useToast();
 * showToast('message', 'success');
 */
export const toastMessage = (
  dispatch: Dispatch,
  content: ReactElement | string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _variant: ToastVariant = 'success',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _timeout = 5000
): void => {
  console.warn(`toastMessage utility is deprecated. Use useToast hook instead. Message: ${content}`);
};

export const isSafariBrowser = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  return isSafari;
};

const removeSnowflakeLastPart = (assetId: string) => {
  const lastPeriodIndex = assetId.lastIndexOf('.');
  if (lastPeriodIndex === -1) {
    return assetId;
  }
  return assetId.substring(0, lastPeriodIndex);
};

export const getCorrectedAssetId = (
  assetId: string,
  dataSourceName: string,
  queryType: QueryTypeEnum,
  relationType: RelationTypeEnum
) => {
  return assetId.split('.').length === 6 &&
    dataSourceName === 'Snowflake' &&
    queryType === QueryTypeEnum.TABLE &&
    relationType === RelationTypeEnum.DOWNSTREAM
    ? removeSnowflakeLastPart(assetId)
    : assetId;
};

/**
 * This checks an env var injected by Webpack during build time, set to `production` for all deployed environments.
 * To distinguish between our different deployed ENVs, use process.env.REACT_APP_ENVIRONMENT
 */
export const isLocalEnvironment = () => {
  return process.env.NODE_ENV !== 'production';
};
